module.exports = __webpack_public_path__ + "img/HZ-B5888.1fe96086.jpg";